import * as enumsApi from "../../backend/store/enumsApi";

const resourceMap = {
  "need-ex-types": "needEx",
  "delivery-types": "deliveryTypes",
  "client-categories": "clientCategories",
  "contact-person-roles": "contactPersonRoles",
  "warehouse-details-states": "warehouseDetailsStates",
  "transport-types": "transportTypes",
  "product-category-types": "productCategoryTypes",
  "shipping-states": "shippingStates",
  "shipping-urgencies": "shippingUrgencies",
  "shipping-invoices": "shippingInvoices",
  "user-roles": "userRoles",
  "employee-roles": "employeeRoles",
  "shipping-phase-delivery-types": "shippingPhaseDeliveryTypes",
  "route-states": "routeStates",
  "shipment-request-states": "shipmentRequestStates",
  "shipping-descriptions": "shippingDescriptions",
  "packages-types": "packagesTypes",
  "shipping-mesurables": "shippingMesurables",
  "shipping-ex-document-in-system": "shippingExDocumentInSystem",
  "shipping-ex-who-doing": "shippingExWhoDoing",
  "release-order-states": "releaseOrderStates",
};

const state = {
  needEx: [],
  deliveryTypes: [],
  clientCategories: [],
  contactPersonRoles: [],
  warehouseDetailsStates: [],
  transportTypes: [],
  productCategoryTypes: [],
  shippingStates: [],
  shippingUrgencies: [],
  shippingInvoices: [],
  userRoles: [],
  employeeRoles: [],
  shippingPhaseStates: [],
  shippingPhaseDeliveryTypes: [],
  routeStates: [],
  shipmentRequestStates: [],
  shippingDescriptions: [],
  packagesTypes: [],
  shippingMesurables: [],
  shippingExDocumentInSystem: [],
  shippingExWhoDoing: [],
  releaseOrderStates: [],
};

const getters = {
  items: state => resource => {
    return state[resourceMap[resource]];
  },
};

const actions = {
  async getItems({ getters, commit }, resource) {
    if (getters.items(resource).length) {
      return;
    }
    const items = await enumsApi.getItems(resource);
    commit("setItems", {
      items,
      resource,
    });
  },
};

const mutations = {
  setItems(state, { items, resource }) {
    state[resourceMap[resource]] = items;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
